import { withAITracking } from '@microsoft/applicationinsights-react-js'
import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router'
import { ai } from '../../TelemetryService'
import { Stresstest } from './Stresstest'
import { StresstestParams } from './StresstestParams'

class PageStresstestComp extends React.Component<RouteComponentProps<StresstestParams>, any> {
    constructor(props) {
        super(props)
    }

    render() {
        return <Stresstest />
    }
}

export const PageStresstest = withRouter(withAITracking(ai.reactPlugin, PageStresstestComp,"PageStresstest"))